import React, { Suspense, lazy } from 'react'

import { Route, Routes, BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'

import { store } from './redux/store'

import Layout from './components/Containers/Layout/Layout'
import PageLoader from './components/UI/PageLoader/PageLoader'

/* MOMENT */
import moment from 'moment-timezone'
moment.tz.setDefault('UTC')

const PlayLazy = lazy(() => import('./components/Pages/Play/Play'))
const ScoreLazy = lazy(() => import('./components/Pages/Score/Score'))
const LeaderBoardLazy = lazy(() =>
  import('./components/Pages/LeaderBoard/LeaderBoard')
)

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path='/*' element={<PlayLazy />} />
              <Route path='/sidecar' element={<PlayLazy />} />
              <Route path='mobile/score' element={<ScoreLazy />} />
              <Route path='mobile/leaderboard' element={<LeaderBoardLazy />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </Provider>
  )
}

export default App
